import { render, staticRenderFns } from "./ResetCertificationForm.vue?vue&type=template&id=94bf5e0a&scoped=true&"
import script from "./ResetCertificationForm.vue?vue&type=script&lang=js&"
export * from "./ResetCertificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bf5e0a",
  null
  
)

/* custom blocks */
import block0 from "@/locales/actions.locale?vue&type=custom&index=0&blockType=i18n&issuerPath=E%3A%5Capp%5CJenkins%5Cworkspace%5CAll_IaaS_Farm%5C0%20nextoreV3bdclient_build%5Csrc%5Csrc%5Cpublic%5Cmodules%5Creset-certification%5Ccomponents%5CResetCertificationForm.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/locales/responseMsg.locale?vue&type=custom&index=1&blockType=i18n&issuerPath=E%3A%5Capp%5CJenkins%5Cworkspace%5CAll_IaaS_Farm%5C0%20nextoreV3bdclient_build%5Csrc%5Csrc%5Cpublic%5Cmodules%5Creset-certification%5Ccomponents%5CResetCertificationForm.vue"
if (typeof block1 === 'function') block1(component)
import block2 from "./ResetCertificationForm.vue?vue&type=custom&index=2&blockType=i18n"
if (typeof block2 === 'function') block2(component)

export default component.exports